var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49995 16.6671L3.07535 17.4045C2.79334 17.4515 2.54885 17.207 2.59585 16.925L3.33328 12.5004L12.9881 2.84558C13.639 2.1947 14.6943 2.1947 15.3451 2.84558L17.1548 4.65522C17.8056 5.3061 17.8056 6.36137 17.1548 7.01225L7.49995 16.6671ZM4.50042 13.101L11.6918 5.90961L14.0907 8.30851L6.89932 15.4999L4.02064 15.9797L4.50042 13.101ZM14.9746 7.42463L12.5757 5.02573L13.872 3.72946C14.0347 3.56674 14.2985 3.56674 14.4612 3.72946L16.2709 5.53911C16.4336 5.70182 16.4336 5.96564 16.2709 6.12836L14.9746 7.42463Z",
    fill: "#2D2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4165 16.4586C10.0713 16.4586 9.79152 16.7385 9.79152 17.0836C9.79152 17.4288 10.0713 17.7086 10.4165 17.7086H17.0832C17.4284 17.7086 17.7082 17.4288 17.7082 17.0836C17.7082 16.7385 17.4284 16.4586 17.0832 16.4586H10.4165Z",
    fill: "#2D2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNew);
export default __webpack_public_path__ + "static/media/edit-new.36e98751f0ffd60e93eff1318f524861.svg";
export { ForwardRef as ReactComponent };